import api from './api';

// 企微成员活码服务
const weworkContactWayService = {
  // 获取活码列表（分页）
  getContactWays: async (params = {}) => {
    try {
      console.log('🚀 准备获取活码列表，参数：', params);
      console.log('📍 请求路径：/wework/contact-way');
      
      const response = await api.get('/wework/contact-way', { params });
      console.log('✅ 获取活码列表成功，数据：', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ 获取活码列表失败:', {
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data,
        请求配置: error.config
      });
      throw error;
    }
  },

  // 获取活码详情
  getContactWayById: async (id) => {
    try {
      console.log('🚀 准备获取活码详情，ID：', id);
      const response = await api.get(`/wework/contact-way/${id}`);
      console.log('✅ 获取活码详情成功');
      return response.data;
    } catch (error) {
      console.error('❌ 获取活码详情失败:', {
        ID: id,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 获取活码详细信息（包含欢迎语）
  getContactWayDetailById: async (id) => {
    try {
      console.log('🚀 准备获取活码详细信息，ID：', id);
      const response = await api.get(`/wework/contact-way/${id}/detail`);
      console.log('✅ 获取活码详细信息成功');
      return response.data;
    } catch (error) {
      console.error('❌ 获取活码详细信息失败:', {
        ID: id,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 创建活码
  createContactWay: async (data) => {
    try {
      console.log('🚀 准备创建活码，数据：', data);
      const response = await api.post('/wework/contact-way', data);
      console.log('✅ 创建活码成功');
      return response.data;
    } catch (error) {
      console.error('❌ 创建活码失败:', {
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 更新活码
  updateContactWay: async (id, data) => {
    try {
      console.log('🚀 准备更新活码，ID：', id, '数据：', data);
      const response = await api.put(`/wework/contact-way/${id}`, data);
      console.log('✅ 更新活码成功');
      return response.data;
    } catch (error) {
      console.error('❌ 更新活码失败:', {
        ID: id,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 删除活码
  deleteContactWay: async (id) => {
    try {
      console.log('🚀 准备删除活码，ID：', id);
      const response = await api.delete(`/wework/contact-way/${id}`);
      console.log('✅ 删除活码成功');
      return response.data;
    } catch (error) {
      console.error('❌ 删除活码失败:', {
        ID: id,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 批量删除活码
  batchDeleteContactWays: async (ids) => {
    try {
      console.log('🚀 准备批量删除活码，IDs：', ids);
      const response = await api.post('/wework/contact-way/batch-delete', { ids });
      console.log('✅ 批量删除活码成功');
      return response.data;
    } catch (error) {
      console.error('❌ 批量删除活码失败:', {
        IDs: ids,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 批量更新活码
  batchUpdateContactWays: async (ids, updateFields) => {
    try {
      console.log('🚀 准备批量更新活码，IDs：', ids, '更新字段：', updateFields);
      const response = await api.post('/wework/contact-way/batch-update', { 
        ids, 
        updateFields 
      });
      console.log('✅ 批量更新活码成功');
      return response.data;
    } catch (error) {
      console.error('❌ 批量更新活码失败:', {
        IDs: ids,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 同步企微活码列表
  syncContactWaysFromWework: async () => {
    try {
      console.log('🚀 准备同步企微活码列表');
      const response = await api.post('/wework/contact-way/sync');
      console.log('✅ 同步企微活码列表成功');
      return response.data;
    } catch (error) {
      console.error('❌ 同步企微活码列表失败:', {
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 获取活码统计信息
  getContactWayStatistics: async () => {
    try {
      console.log('🚀 准备获取活码统计信息');
      const response = await api.get('/wework/contact-way/statistics');
      console.log('✅ 获取活码统计信息成功');
      return response.data;
    } catch (error) {
      console.error('❌ 获取活码统计信息失败:', {
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 根据state参数获取活码详情
  getContactWayByState: async (state) => {
    try {
      console.log('🚀 准备根据state获取活码详情，state：', state);
      const response = await api.get(`/wework/contact-way/by-state/${state}`);
      console.log('✅ 根据state获取活码详情成功');
      return response.data;
    } catch (error) {
      console.error('❌ 根据state获取活码详情失败:', {
        state: state,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 复制活码
  copyContactWay: async (id, copyRequest = {}) => {
    try {
      console.log('🚀 准备复制活码，源ID：', id, '复制参数：', copyRequest);
      const response = await api.post(`/wework/contact-way/${id}/copy`, copyRequest);
      console.log('✅ 复制活码成功');
      return response.data;
    } catch (error) {
      console.error('❌ 复制活码失败:', {
        源ID: id,
        复制参数: copyRequest,
        错误信息: error.message,
        状态码: error.response?.status,
        响应数据: error.response?.data
      });
      throw error;
    }
  },

  // 导出选中活码配置
  exportConfigs: async (params = {}) => {
    try {
      const response = await api.post('/wework/contact-way/export-configs', params, {
        responseType: 'blob',
        timeout: 180000  // 导出操作设置3分钟超时
      });
      return response.data;
    } catch (error) {
      console.error('❌ 导出活码配置失败:', error);
      throw error;
    }
  }
};

export default weworkContactWayService; 